import React from 'react';
import { PensionPage } from '../components/pension-page.component';
import Header from '../components/header.component';
import { AccountAccess } from '../components/account-access.component';
import { Footer } from '../components/footer.component';
import { useTranslation } from 'react-i18next';
import SectionHeader from '../components/common';
import FreelancerCtaSection from '../components/freelancer-call-to-action';
import { InvozioAsFreelancer } from '../components/images/png/icons';
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from '../../common/FunctionUtils';

export const PensionPagePage: React.FC = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/pension?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/pension?lang=${LOCALES.SV_SE}`;


    const schemaMarkup = getSchemaMarkup("pension");

    return (
        <div className="pension-page-wrapper">
            <Header />
            <SEOMetadataComponent
                title={t('PENSION_HERO_TITLE')}
                // description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <SectionHeader
                titleKey={t('PENSION_HERO_TITLE')}
                //   subtitleKey={t('PENSION_PAGE_SUBTITLE')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />

            {/* Main Pension Content */}
            <PensionPage />
            <FreelancerCtaSection
                title={t('LET_INVOZIO_HELP_YOU_AS_FREELANCER')}
                description={[t('FREELANCING_REWARDING_CAREER_TEXT_1'), t('FREELANCING_REWARDING_CAREER_TEXT_2')]}
                buttonText={t('CREATE_FREE_ACCOUNT')}
                imageSrc={InvozioAsFreelancer}
                imageAlt="Freelancer illustration"
            />

            <div className="bg-footer">

                <Footer />
            </div>
        </div>
    );
};

export default PensionPagePage;
